import React, { useState } from 'react';
import { Card, CardHeader, CardContent } from '../../ui/Card';
import { Button } from '../../ui/Button';
import { Dialog } from '@headlessui/react';
import toast from 'react-hot-toast';

export function AccountDeletion() {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const handleDeactivate = () => {
    toast.success('Ihr Konto wurde deaktiviert');
  };

  const handleDelete = () => {
    setIsDeleteModalOpen(false);
    toast.success('Ihr Konto wurde gelöscht');
  };

  return (
    <>
      <Card>
        <CardHeader>
          <h2 className="text-gray-900 dark:text-white text-lg font-semibold">Konto löschen</h2>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            <div className="rounded-lg border border-yellow-200 bg-yellow-50 dark:border-yellow-900/50 dark:bg-yellow-900/20 p-4">
              <div className="flex items-center gap-3">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 256 256" className="text-yellow-600 dark:text-yellow-500">
                  <path d="M236.8,188.09,149.35,36.22h0a24.76,24.76,0,0,0-42.7,0L19.2,188.09a23.51,23.51,0,0,0,0,23.72A24.35,24.35,0,0,0,40.55,224h174.9a24.35,24.35,0,0,0,21.33-12.19A23.51,23.51,0,0,0,236.8,188.09ZM222.93,203.8a8.5,8.5,0,0,1-7.48,4.2H40.55a8.5,8.5,0,0,1-7.48-4.2,7.59,7.59,0,0,1,0-7.72L120.52,44.21a8.75,8.75,0,0,1,15,0l87.45,151.87A7.59,7.59,0,0,1,222.93,203.8ZM120,144V104a8,8,0,0,1,16,0v40a8,8,0,0,1-16,0Zm20,36a12,12,0,1,1-12-12A12,12,0,0,1,140,180Z" />
                </svg>
                <div>
                  <p className="text-sm font-medium text-yellow-800 dark:text-yellow-500">Warnung</p>
                  <p className="text-sm text-yellow-700 dark:text-yellow-400">Diese Aktion kann nicht rückgängig gemacht werden</p>
                </div>
              </div>
            </div>

            <div className="space-y-4">
              <Button
                variant="secondary"
                className="w-full"
                onClick={handleDeactivate}
              >
                Konto deaktivieren
              </Button>

              <Button
                className="w-full bg-red-600 hover:bg-red-700"
                onClick={() => setIsDeleteModalOpen(true)}
              >
                Konto permanent löschen
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>

      <Dialog
        open={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        className="relative z-50"
      >
        <div className="fixed inset-0 bg-black/20 dark:bg-black/40" aria-hidden="true" />
        
        <div className="fixed inset-0 flex items-center justify-center p-4">
          <Dialog.Panel className="w-full max-w-md bg-white dark:bg-dark-card rounde d-xl shadow-xl">
            <div className="p-6">
              <Dialog.Title className="text-lg font-semibold text-gray-900 dark:text-white">
                Konto permanent löschen
              </Dialog.Title>
              <Dialog.Description className="mt-2 text-sm text-gray-500 dark:text-gray-400">
                Sind Sie sicher, dass Sie Ihr Konto permanent löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden. Alle Ihre Daten werden unwiderruflich gelöscht.
              </Dialog.Description>

              <div className="mt-6 space-y-2">
                <input
                  type="text"
                  placeholder="Geben Sie 'LÖSCHEN' ein zur Bestätigung"
                  className="w-full px-4 py-2 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-dark-hover text-gray-900 dark:text-white focus:ring-2 focus:ring-primary/20 focus:border-primary"
                />
                
                <div className="flex gap-3">
                  <Button
                    variant="secondary"
                    className="flex-1"
                    onClick={() => setIsDeleteModalOpen(false)}
                  >
                    Abbrechen
                  </Button>
                  <Button
                    className="flex-1 bg-red-600 hover:bg-red-700"
                    onClick={handleDelete}
                  >
                    Permanent löschen
                  </Button>
                </div>
              </div>
            </div>
          </Dialog.Panel>
        </div>
      </Dialog>
    </>
  );
}